<template>
  <PrizeBannerModal
    :draw-label="$t('highfrequencygame.prizebanner.draw')"
    :headline="$t('highfrequencygame.prizebanner.headline.new')"
    :tracking="{
      action: 'play_high_frequency_game',
      topicKey: 'high-frequency-game-prize-modal',
    }"
    v-bind="{ visibleJackpot }"
    @close="emit('close')"
  >
    <HighFrequencyGamePrizeModalOptions />

    <HighFrequencyGamePrizeModalTable />
    <HighFrequencyGamePrizeModalHint class="mt-100" />
  </PrizeBannerModal>
</template>

<script lang="ts" setup>
type Emits = {
  (e: 'close'): void
}

const emit = defineEmits<Emits>()

const { visibleJackpot } = useHighFrequencyGame()
</script>
